import React, { useState } from "react";

import { serverUrl, apiEndpoints, assetBase } from "../../config";

import PostSingle from "../../partials/posts/postSingle";

import MicNoneIcon from "@mui/icons-material/MicNone";
import { Typography } from "@mui/material";

export default function PodcastSingle(props) {
  const [post, setPost] = useState(null);

  const renderPostAudio = (_post) => {
    if (!_post) return null;

    // Published: signed, same-origin asset from book.json. field_audio is a
    // relative `assets/<file>?sig=…` path; assetBase resolves same-origin off
    // the NFS symlink on deployed hosts (dev-files on localhost) and the sig is
    // verified there. Preview (unpublished draft) is served by Drupal.
    let audioSrc;
    if (!props.preview) {
      // book.json and the live list/CRUD rows both expose the audio under
      // `field_audio`; published rows carry a signed relative
      // `assets/<file>?sig=…` path.
      audioSrc = `${assetBase}/podcast/${_post.id}/${_post.id}/${_post.field_audio}`;
    } else {
      const fileToken = _post.file_access_token;
      audioSrc = fileToken
        ? `${serverUrl}/shared/files/${_post.filename}?access_token=${fileToken}`
        : _post.field_audio;
    }

    return (
      <div className="post-podcast-container">
        <audio controls className="post-podcast w-100 mt-4 mb-3">
          <source src={audioSrc} alt={`Audio for ${_post.title}`} />
        </audio>
        <div className="artist-container d-flex align-items-center justify-content-center mb-4">
          <div className="artist">
            <Typography
              className="d-flex"
              owner="client"
              variant="body1"
              color="clientPrimary.main"
            >
              <MicNoneIcon className="me-1" sx={{ fontSize: 20 }} />
              {_post.field_artist}
            </Typography>
          </div>
        </div>
      </div>
    );
  };

  return (
    <PostSingle
      preview={props.preview}
      apiEndpoint={apiEndpoints.podcasts}
      featuredImageEnabled={true}
      entityFavoritesContentType={"podcast"}
      previewReturnRoute={"/podcasts-creator"}
      returnRoute={"/podcasts"}
      backBtnText={"Podcast Library"}
      screenClassName={"podcasts"}
      v2Bundle={"podcast"}
      logCustomEventType={"Podcast"}
      entityType={"podcast"}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
      {renderPostAudio(post)}
    </PostSingle>
  );
}
